export type CCTokenResponse = {
  message: string | undefined;
  expiry: string | undefined;
  validationError: string | undefined;
  errorCode: string | undefined;
  errorMessage: string | undefined;
};

const getCCIFrameOptions = () => {
  return {
    // See documentation for all available options: https://developer.fiserv.com/product/CardPointe/docs/?path=docs/documentation/HostediFrameTokenizer.md&branch=main#optional-parameters
    formatinput: true, // formats the card number field with spaces when typing
    //enhancedresponse: true, // returns more detailed error info
    //sendcardtypingevent: true, // sends an event when the user types in the card number field and when the user stops typing
    usecvv: true,
    useexpiry: true,
    useexpiryfield: true, // makes expiration field a text entry instead of dropdown
    cardinputmaxlength: 19, // sets the max length of the card number field
    cardnumbernumericonly: true, // only allows numbers in the card number field
    cvvnumericonly: true, // only allows numbers in the cvv field
    cardlabel: 'Card number',
    cardtitle: 'Card number', // aria-label for the card number field
    cvvlabel: 'Security code *',
    cvvtitle: 'Security code *', // aria-label for the cvv field
    expirylabel: 'Exp. date (MM/YYYY)',
    expirymonthtitle: 'Month', // aria-label for the expiration month field
    expiryyeartitle: 'Year', // aria-label for the expiration year field
    // invalidcreditcardevent: true,
    // invalidexpiryevent: true,
    // invalidcvvevent: true,
    selectinputdelay: 100,
    tokenizewheninactive: true,
    inactivityto: 1000,
    orientation: 'default',
  };
};

const getIFrameCSSOptions = () => {
  return {
    // See documentation for allowed css props: https://developer.fiserv.com/product/CardPointe/docs/?path=docs/documentation/HostediFrameTokenizer.md&branch=main#iframe-styling
    body: {
      padding: '0',
      margin: '0',
    },
    form: {
      'font-family': 'sans-serif',
      color: '#373A36',
    },
    label: {
      'font-size': '15px',
      height: '20px',
      'font-weight': 'normal',
    },
    input: {
      border: '1px solid #D1CABF',
      height: '40px',
      'margin-top': '8px',
      'margin-bottom': '16px',
      padding: '2px 8px',
      'line-height': '24px',
      width: 'calc(100% - 20px)',
      'max-width': '350px',
      'border-radius': '6px',
      'font-size': '16px',
      color: '#373A36',
      background: '#FFFFFF',
      'letter-spacing': '0px',
    },
    'input:focus': {
      border: '1px solid #004D71',
      outline: 'none',
    },
    'input:hover': {
      border: '1px solid #004D71',
      outline: 'none',
    },
    'input.error': {
      'border-color': '#AD0322',
    },
    '#ccnumfield': {},
    '#ccexpiryfieldmonth': {
      width: '50px',
      maxlength: '2',
      'text-align': 'right',
    },
    '#ccexpirylabel': {},
    '#ccexpiryfieldyear': {
      width: '50px',
      maxlength: '2',
    },
    '#cccvvlabel': {
      'padding-left': '0',
    },
    '#cccvvfield': {
      width: '150px',
      align: 'right',
      'margin-left': '0',
    },
  };
};

export const getCardConnectSrc = (baseUrl: string) => {
  // build params from iframe options
  let params: string[] = [];
  for (const [key, value] of Object.entries(getCCIFrameOptions())) {
    params = [...params, `${key}=${value}`];
  }

  // build the css param
  let cssString = '';
  for (const [key, value] of Object.entries(getIFrameCSSOptions())) {
    let cssProps = '';
    for (const [subkey, subvalue] of Object.entries(value)) {
      cssProps += `${subkey}:${subvalue};`;
    }
    cssString += `${key}{${cssProps}}`;
  }
  params = [...params, `css=${encodeURIComponent(cssString)}`];

  return `${baseUrl}?${params.join('&')}`;
};
